export default __webpack_public_path__ + "static/media/type.268221d2.wav";